import { useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../../../components/CustomButton";
import { APP_COLOR } from "../../../const";
import { numberFormat } from "../../../helper";
import { toast } from "react-toastify";
import * as _ from "lodash";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addCartDatas } from "../../../redux/reducers/cartReducer";

function PriceOptionsModal({
  addOrder,
  selectedProductPrice,
  setSelectedProductPrice,
  selectedProduct,
  showPriceOptionModal,
  updateOrder,
  setShowPriceOptionModal,
  setCartDatas,
  cartDatas,
  activeCart,
}) {
  const [activePrice, setActivePrice] = useState(0);
  // const { cartDatas } = useSelector((state) => state?.cart)
  // const dispatch = useDispatch();

  // console.log("cartDatas redux: ", cartDatas)

  const _onSubmit = () => {
    setSelectedProductPrice(
      selectedProduct?.priceOptions[activePrice]?.price ??
      selectedProduct?.price
    );
    _updateOrder();
    setShowPriceOptionModal(false);


    toast.success(
      `${selectedProduct?.name} ${numberFormat(
        selectedProduct?.priceOptions[activePrice]?.price
      )} ${selectedProduct?.currency}`,
      {
        position: "top-right",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
    setActivePrice(0);
  };

  // Update object within an array
  const _updateOrder = () => {
    const _oldCartDatas = [...cartDatas];
    // TODO: Find cart
    const _cartIndex = _.findIndex(cartDatas, { label: activeCart });
    if (_cartIndex < 0) return;

    // TODO: Find order product
    const _orderIndex = _.findIndex(cartDatas[_cartIndex]?.data?.orders, {
      product: selectedProduct?.id,
    });
    if (_orderIndex < 0) {
      addOrder({
        product: selectedProduct,
        productPrice: selectedProduct?.priceOptions[activePrice]?.price,
      });
      return;
    }
    _oldCartDatas[_cartIndex].data.orders[_orderIndex].price =
      selectedProduct?.priceOptions[activePrice]?.price ??
      selectedProduct?.price;
    _oldCartDatas[_cartIndex].data.orders[_orderIndex].totalPrice =
      (selectedProduct?.priceOptions[activePrice]?.price ??
        selectedProduct?.price) *
      _oldCartDatas[_cartIndex].data.orders[_orderIndex].amount;
    if (!_.isEmpty(_oldCartDatas)) {
      setCartDatas(_oldCartDatas);
      // set data to redux
      // dispatch(addCartDatas(_oldCartDatas))
    }
  };

  return (
    <Modal
      size="md"
      show={showPriceOptionModal}
      onHide={() => setShowPriceOptionModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>ເລືອກລາຄາ ({selectedProduct?.currency})</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            flexWrap: "wrap",
          }}>
          {selectedProduct?.priceOptions?.length > 0 &&
            selectedProduct?.priceOptions?.map((price, index) => {
              return (
                <CustomButton
                  onClick={() => setActivePrice(index)}
                  key={(price + index).toString()}
                  title={
                    "ລາຄາ" +
                    (index + 1) +
                    ": " +
                    numberFormat(price.price) +
                    "/" +
                    numberFormat(price.contain)
                  }
                  background={"#fff"}
                  color={activePrice === index ? APP_COLOR : "#616161"}
                  border={
                    "1px solid " + (activePrice === index ? APP_COLOR : "#eee")
                  }
                  borderRadius={5}
                  width={200}
                  height={40}
                  margin={6}
                  marginleft={10}
                />
              );
            })}
        </div>
        <CustomButton
          onClick={_onSubmit}
          title={"ຕົກລົງ"}
          margin={"20px 0px 0px 0px"}
          borderRadius={"0px 0px 5px 5px"}
        />
      </Modal.Body>
    </Modal>
  );
}

export default PriceOptionsModal;
